import { graphql } from "../../generated";

export const MUTATE_USER = graphql(`
  mutation MutateUser(
    $theme: UserThemeInput
    $email: String
    $avatarUrl: String
  ) {
    user(theme: $theme, email: $email, avatarUrl: $avatarUrl)
  }
`);
